module.exports = __webpack_public_path__ + "static/media/draw-square.599eaf39.svg";